var c = Object.defineProperty;
var h = (i, e, t) => e in i ? c(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var r = (i, e, t) => (h(i, typeof e != "symbol" ? e + "" : e, t), t);
const l = ";expires=Thu, 01 Jan 1970 00:00:00 GMT", d = "MartinBrosIdentity", k = "IdToken", o = "AccessToken", u = "RefreshToken";
class a {
  constructor({ isLocal: e = !1, environmentId: t, cookieDomain: n, maxAge: s = 86400 }) {
    r(this, "cookieSuffix");
    r(this, "environmentId");
    this.cookieSuffix = `domain=${n}; path=/; SameSite=Strict; max-age=${s}; ${e ? "" : "Secure "}`, this.environmentId = t;
  }
  buildTokenCookie(e, t) {
    const n = {
      environment: this.environmentId,
      token: e,
      userType: t
    };
    return JSON.stringify(n);
  }
  escapeValue(e) {
    return btoa(encodeURIComponent(e));
  }
  unescapeValue(e) {
    return decodeURIComponent(atob(e));
  }
  writeCookie(e, t, n = !1) {
    document.cookie = `${e}=${this.escapeValue(t)}; ${this.cookieSuffix}${n ? l : ""}`;
  }
  findCookie(e) {
    var n;
    const t = (n = document.cookie.split("; ").find((s) => s.startsWith(`${e}=`))) == null ? void 0 : n.split("=")[1];
    return t ? this.unescapeValue(t) : null;
  }
  buildKey(e) {
    return `${d}.${e}`;
  }
  getToken(e) {
    const t = this.findCookie(e);
    if (!t)
      return null;
    try {
      return JSON.parse(t);
    } catch (n) {
      return console.warn("Failed parsing cookie token: ", (n == null ? void 0 : n.message) ?? "unknown error"), null;
    }
  }
  getIdToken() {
    const e = this.buildKey(k);
    return this.getToken(e);
  }
  getAccessToken() {
    const e = this.buildKey(o);
    return this.getToken(e);
  }
  getRefreshToken() {
    const e = this.buildKey(u);
    return this.getToken(e);
  }
  /**
   * Retrieve the stored tokens from the browser cookie store
   * @returns {ApiTokenResponse} An object containing the id, refresh, and access tokens.
   * Returns null if the tokens are missing or do not match the current environment.
   */
  retrieveLastUserTokens() {
    const e = this.getIdToken();
    if (!e)
      return null;
    const t = this.getAccessToken();
    if (!t)
      return null;
    const n = this.getRefreshToken();
    return n ? e.environment !== this.environmentId || t.environment !== this.environmentId || n.environment !== this.environmentId ? (this.expireUserTokens(), null) : {
      id_token: e.token,
      access_token: t.token,
      refresh_token: n.token
    } : null;
  }
  /**
   * Retrieve the userType of the stored user
   * @returns The stored user's cognito userType
   */
  retrieveUserType() {
    var e;
    return ((e = this.getIdToken()) == null ? void 0 : e.userType) ?? null;
  }
  /**
   * Clear the user's tokens from the browser cookie store
   */
  expireUserTokens() {
    this.writeCookie(this.buildKey(k), "", !0), this.writeCookie(this.buildKey(o), "", !0), this.writeCookie(this.buildKey(u), "", !0);
  }
  /**
   * Persists the user's JWT tokens to the browser's cookie store
   * @param userTokens An object containing the id, access, and refresh tokens
   * @param userType The user's cognito userType (CUSTOMER, PUNCH_OUT, EMPLOYEE)
   */
  persistUserTokens(e, t) {
    this.writeCookie(this.buildKey(k), this.buildTokenCookie(e.id_token, t)), this.writeCookie(this.buildKey(o), this.buildTokenCookie(e.access_token)), this.writeCookie(this.buildKey(u), this.buildTokenCookie(e.refresh_token));
  }
  /**
   * Updates the persisted access token with the given token
   * @param accessToken The JWT access token to persist
   */
  persistUserAccessToken(e) {
    this.writeCookie(this.buildKey(o), this.buildTokenCookie(e));
  }
}
export {
  a as CookieDao
};
